import { Dispatch, Action } from 'redux'
import { NotificationsSettingsMainMapDispatchReturnType } from './types/NotificationsSettingsMainMapDispatchReturnType'

export const NotificationsSettingsMainMapDispatch = (
  _dispatch: Dispatch<Action>
): NotificationsSettingsMainMapDispatchReturnType => {
  return {}
}
